import { render, staticRenderFns } from "./AddressPlanningSpecifications.vue?vue&type=template&id=0eff3d91&scoped=true&lang=pug&"
import script from "./AddressPlanningSpecifications.vue?vue&type=script&lang=ts&"
export * from "./AddressPlanningSpecifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eff3d91",
  null
  
)

export default component.exports